'use strict';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var CustomStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('at station', Q('geo:arrived'))
	.add('work completed', Q('geo:location_skipped', 'geo:departed'))
	.add('awaiting approval', Q('form_skipped'))


export default function(incident) {
	CustomStateDiagram.updateIncident(incident);
}
